export default {
  label: "Asset-Verwaltung",
  tabs: {
    assets: {
      label: "Assets",
      assetList: "Asset Liste",
      asset: "Asset",
      newAsset: "Neues Asset",
      editAsset: "Asset bearbeiten",
      createAsset: {
        label: "Asset erstellen",
        assetDescriptor: "Asset-Beschreibung",
      },
      noAssetsCreatedYet: "Es wurden noch keine Assets erstellt",
      createFirstAsset: "Erstellen Sie Ihr erstes Asset",
      createAssetHelperText: "Erstellen Sie ein Asset, um Ihre physischen Gegenstände zu verwalten",
      detailsOverview: {
        assetInformation: "Asset-Informationen",
        relatedAssets: "Verwandte Assets",
        assetType: "Asset-Typ",
        assetModel: "Asset-Modell",
        serialNo: "Seriennummer",
        parentAsset: "Übergeordnetes Asset",
        childAssets: "Untergeordnete Assets",
        childDevices: "Untergeordnete Geräte",
      },
    },
    assetGroups: {
      label: "Asset-Gruppen",
      list: "Asset-Liste",
      activities: "Aktivitäten",
      newAssetGroup: "Neue Asset-Gruppe",
      sort: {
        labelAsc: "Aufsteigend",
        labelDesc: "Absteigend",
      },
    },
    assetTags: {
      title: "Tags",
      createOrSelectTags: "Tags erstellen oder auswählen",
      updateTags: "Tags aktualisieren",
    },
    assetTypes: {
      label: "Asset Typen",
      labelWithCount: "Asset Typen ({count})",
      newAssetType: "Neuer Asset-Typ",
      editAssetType: "Asset-Typ bearbeiten",
      resetToDefaultValue: "Zurücksetzen auf Standardwert",
      noAttributesAssigned: "Keine Attribute zugeordnet",
      createFirstAssetType: "Erstellen Sie Ihren ersten Asset-Typ",
      createAssetTypeHelperText: "Asset-Typen, die Sie erstellen, werden hier angezeigt.",
      createAssetType: "Asset-Typ erstellen",
      addAssetType: "Asset-Typ hinzufügen",
      noTypeSelected: " Wählen Sie einen Typ aus der Liste aus, um Details anzuzeigen",
      deleteAssetType: {
        title: "Asset-Typ löschen",
        message:
          "Sind Sie sicher, dass Sie den ausgewählten Asset-Typ löschen möchten? Dies kann nicht rückgängig gemacht werden.",
      },

      deleteAssetTypeWithModelsError: {
        title: "Asset-Typ kann nicht gelöscht werden",
        deleteAssetTypeErrorMessage:
          "Bitte achten Sie darauf, nur Asset-Typen zu löschen, denen keine Modelle zugewiesen sind!",
      },
      editAssetTypeWithModelsError: {
        title: "Asset-Typ kann nicht bearbeitet werden",
        editAssetTypeErrorMessage:
          "Bitte achten Sie darauf, nur Asset-Typen zu bearbeiten, denen keine Modelle zugewiesen sind!",
      },
      attributeValidationError: {
        generalMessage: "Validierungsfehler: Der Standardwert entspricht nicht den Anforderungen",
        dataTypeError: "Standardwert entspricht nicht dem erforderlichen Datentyp",
      },
      attributeValidationSuccess: {
        defaultValueSaved: "Standardwerte erfolgreich gespeichert",
      },
      tabs: {
        assetTypeTree: {
          label: "Hierarchie",
          errorLoadingHierarchy: "Fehler beim Laden der Hierarchie",
        },
        models: {
          label: "Modelle",
          newAssetModel: "Neues Anlagenmodell",
          assetModelDetailsView: "Anlagenmodell-Details",
          updateAssetModel: "Anlagenmodell bearbeiten",
          modelDeleteErrorMessage:
            "Asset-Modell konnte nicht gelöscht werden. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support.",
          hierarchy: {
            label: "Hierarchie",
            errorLoadingHierarchy: "Fehler beim Laden der Hierarchie",
            includedDevices: "Enthaltene Geräte",
            includedAssets: "Enthaltene Assets",
          },
          attributes: {
            noDefaultValue: "Kein Standardwert",
          },
          singularModel: "Modell",
          modelForm: {
            selected: "ausgewählt",
            searchAttributeSets: "Attributsätze durchsuchen...",
            selectedSets: "Ausgewählte Sätze",
          },
          editAssetModelError: {
            title: "Asset-Modell kann nicht bearbeitet werden",
            editAssetModelErrorMessage:
              "Asset-Modell konnte nicht bearbeitet werden, weil es bereits Assets zugewiesen hat!",
          },
          createModel: "Modell erstellen",
          createFirstAssetModel: "Erstellen Sie Ihr erstes Asset-Modell",
          createAssetModelHelperText: "Asset-Modelle, die Sie für diesen Typ erstellen, werden hier angezeigt.",
          noAssetModelsCreatedYet: "Es wurden noch keine Asset-Modelle erstellt",
          assetAttributeSetExplaination:
            "Wählen Sie die Attributsätze aus, die für Instanzen dieser Modellversion angezeigt werden sollen. Sie können jetzt oder während der Instanzerstellung Werte eingeben, und alle Werte können später für jede Instanz aktualisiert werden.",
        },
        assets: {
          noAssetsOrModelsYet: "Für diesen Asset-Typ existieren noch keine Assets",
        },
      },
      deleteAssetTypeError: {
        title: "Asset-Typ kann nicht gelöscht werden",
        deleteAssetTypeErrorMessage:
          "Bitte achten Sie darauf, nur Asset-Typen zu löschen, denen keine Modelle zugewiesen sind!",
      },
      editAssetTypeError: {
        title: "Asset-Typ kann nicht bearbeitet werden",
        editAssetTypeErrorMessage: "Asset-Typ konnte nicht bearbeitet werden, weil er bereits Assets zugewiesen hat!",
      },
      deleteAssetModelError: {
        title: "Asset-Modell kann nicht gelöscht werden",
        deleteAssetModelHasAssetsError: {
          deleteAssetModelWarningMessagePluralModel:
            "Sie können diese Asset-Modelle nicht löschen, wenn ihnen Assets zugewiesen sind. Die folgenden Modelle haben Assets zugewiesen:",
          deleteAssetModelWarningMessageSingularModel:
            "Sie können ein Asset-Modell nicht löschen, wenn ihm Assets zugewiesen sind. Das folgende Modell hat Assets zugewiesen:",
        },
        genericDeleteAssetModelError:
          "Beim Versuch, das ausgewählte Asset-Modell zu löschen, ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        warningModal: {
          title: "Asset-Modell(e) löschen",
          titleSingular: "Asset-Modell löschen",
          titlePlural: "Asset-Modelle löschen",
          message:
            "Sind Sie sicher, dass Sie das ausgewählte Asset-Modell löschen möchten? Dies kann nicht rückgängig gemacht werden.",
          messageSingular:
            "Sind Sie sicher, dass Sie das ausgewählte Asset-Modell löschen möchten? Dies kann nicht rückgängig gemacht werden.",
          messagePlural:
            "Sind Sie sicher, dass Sie die ausgewählten Asset-Modelle löschen möchten? Dies kann nicht rückgängig gemacht werden.",
        },
      },
    },
    assetDetails: {
      label: "Asset-Details",
      assetInformation: "Asset-Information",
      relatedAssets: "Verwandte Assets",
      childAssets: "Child Assets",
      parentAsset: "Parent Asset",
      childDevices: "Child Devices",
      fcsSetUp: {
        noChildAssetsAssignedMessage:
          "Alle vorhandenen Instanzen sind entweder bereits einer übergeordneten Instanz zugeordnet oder ihre untergeordneten Zuordnungen sind unvollständig.",
        assignDeviceModal: {
          title: "Gerät zuweisen",
          label: "Gerät auswählen",
        },
        assignAssetModal: {
          title: "Asset zuweisen",
          label: "Asset auswählen",
        },
        pairingComplete: "Pairing abgeschlossen",
        pairingInComplete: "Pairing nicht abgeschlossen",
        deviceAssigned: "Zugewiesen",
        deviceNotAssigned: "Nicht zugewiesen",
        noTreeDefined: "Für dieses Asset-Modell ist keine Baumhierarchie definiert",
        noDeviceAssigned: "Für dieses Asset ist kein Gerät zugewiesen",
      },
      attributes: {
        noData: "Keine verfügbaren Asset-Attributdaten gefunden",

        validationError: {
          generalMessage: "Validierungsfehler: Der Eingabewert entspricht nicht den Anforderungen",
          dataTypeError: "Eingabewert entspricht nicht dem erforderlichen Datentyp",
        },
        saveSuccess: "Asset-Attribut erfolgreich gespeichert",
        edit: "Bearbeiten",
      },
    },
    assetAttributeFieldsAndSets: {
      label: "Attributfelder und -Sätze",
      assetAttributes: {
        formLabels: {
          attributeName: "Attributname",
          attributeFields: "Attributfelder",
          measurementTooltip:
            "Wählen Sie, ob dieses Attribut eine messbare Größe darstellt. Falls ja, wählen Sie einen Messtyp mit vordefinierten Einheiten. Falls nein, definieren Sie ein benutzerdefiniertes Feld mit einem grundlegenden Datentyp (z.B. Text, Zahl).",
        },
        deleteAssetAttribute: {
          title: "Attributsatz löschen",
          deleteMessage:
            "Sind Sie sicher, dass Sie es löschen möchten? Diese Aktion wirkt sich nicht auf Geräte- oder Asset-Modelle und deren Instanzen aus.",
          assignedToModelsMessage:
            "HINWEIS: Einige Assets- oder Geräte-Modelle haben dieses Attributfeld zur Anzeige von Attributwerten ihrer Instanzen zugewiesen. Das Löschen dieses Attributfelds wirkt sich auf alle diese Instanzen aus. Sind Sie sicher, dass Sie es löschen möchten?",
          deleteAssetAttributeError: {
            title: "Attributfeld kann nicht gelöscht werden",
            deleteAttributeGenericErrorMessage:
              "Beim Versuch, das ausgewählte Attributfeld zu löschen, ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
          },
        },
        validationRules: {
          name: {
            alreadyExists: "Attributname existiert bereits",
          },
        },
        validationError: {
          generalMessage: "Validierungsfehler: Der Eingabewert entspricht nicht den Anforderungen",
          dataTypeError: "Eingabewert entspricht nicht dem erforderlichen Datentyp",
        },
        noAssetAttributeDescription: "Keine Asset-Attributbeschreibung gefunden",
      },
      assetAttributeSets: {
        label: "Attribut-Sets",
        createAttributeSet: "Attribut-Set erstellen",
        createFirstAttributeSet: "Erstellen Sie Ihren ersten Attributsatz",
        createAttributeSetHelperText:
          "Die von Ihnen erstellten Attributsätze werden hier angezeigt. Anschließend können Sie mit der Erstellung und Verwaltung von Attributfeldern beginnen.",
        editAssetAttributeSet: "Attribut-Set bearbeiten",
        addAssetAttributeSet: "Attribut-Set hinzufügen",
        emptyState: {
          noResults: "Es sieht so aus, als hätten Ihre aktuellen Filter keine Ergebnisse geliefert.",
          suggestions: [
            "Überprüfen oder löschen Sie einige Filter",
            "Erweitern Sie Ihre Kriterien",
            "Prüfen Sie, ob Sie Filter zu restriktiv kombinieren",
            "Überprüfen Sie die Rechtschreibung oder Tippfehler in Ihrem Suchbegriff",
            "Versuchen Sie, nach einem anderen Attribut zu suchen",
          ],
          resetAllFilters: "Alle Filter zurücksetzen",
        },
        deleteAttributeSet: {
          title: "Attribut-Set löschen",
          deleteMessage:
            "Sind Sie sicher, dass Sie es löschen möchten? Diese Aktion wirkt sich nicht auf Geräte- oder Asset-Modelle und deren Instanzen aus.",
          deleteAttributeSetError: {
            title: "Fehler beim Löschen des Attribut-Sets",
            message:
              "Beim Versuch, das Attribut-Set zu löschen, ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
          },
          assignedToModelsWarningMessage:
            "HINWEIS: Einige Modelle haben dieses Set zur Anzeige von Attributwerten ihrer Instanzen zugewiesen. Das Löschen dieses Sets wirkt sich auf alle diese Instanzen aus. Sind Sie sicher, dass Sie es löschen möchten?",
        },
      },
      noAssetAttributeDescription: "Keine Asset-Attributbeschreibung gefunden",
    },
  },
  deleteAssets: {
    label: "Assets löschen",
    message:
      "Sind Sie sicher, dass Sie das/die ausgewählte(n) Asset(s) löschen möchten? Dies kann nicht rückgängig gemacht werden.",
    assetsNotDeletedLabel: "Asset(s) konnte(n) nicht gelöscht werden",
    assetsWithChildrenOrParentsMessage:
      "Das/die folgende(n) Asset(s) konnte(n) nicht gelöscht werden, da es bereits übergeordnete oder untergeordnete Assets gibt:",
    errorDeleteAssetsTitle: "Fehler beim Löschen des/der Asset(s)",
    errorDeleteAssetsMessage:
      "Beim Versuch, das/die ausgewählte(n) Asset(s) zu löschen, ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  },
};
